/** Listing indexer staging host (GraphQL + NFTX scraper REST). */
export const LISTING_INDEXER_STAGING_ORIGIN = 'https://listing-indexer-staging.nfthost.org';
export const LISTING_INDEXER_STAGING_GRAPHQL = `${LISTING_INDEXER_STAGING_ORIGIN}/graphql`;
export const LISTING_INDEXER_STAGING_NFTX_SCRAPER_BASE = `${LISTING_INDEXER_STAGING_ORIGIN}/api/scraper/nftx/price/`;
